var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-box"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_c('video',{attrs:{"autoplay":"autoplay","name":"media","data-autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.bannervideo,"type":"video/mp4"}})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9b1aca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bannerView.vue
// module id = null
// module chunks = 